import React, { Component } from 'react'
import { Calendar } from 'react-native-calendars'
import { getTheme } from '@/components/calendar/theme'

// TODO: this is pulled from https://github.com/lazaronixon/react-native-date-range-picker?
// it needs a refactor

const XDate = require('xdate');

const today = new Date().toISOString().split('T')[0]

type Props = {
  initialRange: string[],
  onSuccess: (start: string, end: string) => void,
  theme: {
    markColor: string,
    markTextColor: string,
  },
  /**
   * Days already covered by another period, as 'yyyy-MM-dd'. Dotted rather than filled, so they
   * stay readable underneath a selection: the save is refused if the two overlap, and being told
   * that without being shown what you hit is no use to anyone.
   */
  busyDays?: string[],
  busyColor?: string,
};

export default class DateRangePicker extends Component<Props> {

  state = { isFromDatePicked: false, isToDatePicked: false, markedDates: {}, fromDate: '' }

  componentDidMount() { this.setupInitialRange() }

  onDayPress = (day: { year?: number; month?: number; day?: number; timestamp?: number; dateString: any; }) => {
    if (!this.state.isFromDatePicked || (this.state.isFromDatePicked && this.state.isToDatePicked)) {
      this.setupStartMarker(day)
      this.props.onSuccess(day.dateString, day.dateString)
    } else if (!this.state.isToDatePicked) {
      let markedDates = { ...this.state.markedDates }
      let [mMarkedDates, range] = this.setupMarkedDates(this.state.fromDate, day.dateString, markedDates)
      if (range >= 0) {
        this.setState({ isFromDatePicked: true, isToDatePicked: true, markedDates: mMarkedDates })
        this.props.onSuccess(this.state.fromDate, day.dateString)
      } else {
        this.setupStartMarker(day)
        this.props.onSuccess(day.dateString, day.dateString)
      }
    }
  }

  setupStartMarker = (day: { year?: number | undefined; month?: number | undefined; day?: number | undefined; timestamp?: number | undefined; dateString: any; }) => {
    let markedDates = { [day.dateString]: { startingDay: true, color: this.props.theme.markColor, textColor: this.props.theme.markTextColor } }
    this.setState({ isFromDatePicked: true, isToDatePicked: false, fromDate: day.dateString, markedDates: markedDates })
  }

  setupMarkedDates = (fromDate: string, toDate: string, markedDates: { [x: string]: { startingDay?: boolean; endingDay?: boolean; color: any; textColor: any; } }) => {
    let mFromDate = new XDate(fromDate)
    let mToDate = new XDate(toDate)
    let range = mFromDate.diffDays(mToDate)
    if (range >= 0) {
      if (range == 0) {
        markedDates = { [toDate]: { color: this.props.theme.markColor, textColor: this.props.theme.markTextColor } }
      } else {
        for (var i = 1; i <= range; i++) {
          let tempDate = mFromDate.addDays(1).toString('yyyy-MM-dd')
          if (i < range) {
            markedDates[tempDate] = { color: this.props.theme.markColor, textColor: this.props.theme.markTextColor }
          } else {
            markedDates[tempDate] = { endingDay: true, color: this.props.theme.markColor, textColor: this.props.theme.markTextColor }
          }
        }
      }
    }
    return [markedDates, range]
  }

  setupInitialRange = () => {
    if (!this.props.initialRange || !this.props.initialRange.length) return
    let [fromDate, toDate] = this.props.initialRange
    let markedDates = { [fromDate]: { startingDay: true, color: this.props.theme.markColor, textColor: this.props.theme.markTextColor } }
    let [mMarkedDates, range] = this.setupMarkedDates(fromDate, toDate, markedDates)
    this.setState({ markedDates: mMarkedDates, fromDate: fromDate })
  }

  // The selection sits on top of the busy dots rather than replacing them, so a day that is both
  // keeps its dot and the crew member can see exactly where their pick runs into what is there.
  withBusyDays = (markedDates: { [date: string]: object }) => {
    const { busyDays, busyColor } = this.props
    if (!busyDays || !busyDays.length) return markedDates

    const merged: { [date: string]: object } = {}

    busyDays.forEach(day => {
      merged[day] = { marked: true, dotColor: busyColor || '#8E8E93' }
    })

    Object.keys(markedDates).forEach(day => {
      merged[day] = { ...merged[day], ...markedDates[day] }
    })

    return merged
  }

  render() {
    return (
      <Calendar
        markingType="period"
        monthFormat="MMMM yyyy"
        current={this.state.fromDate || today}
        markedDates={this.withBusyDays(this.state.markedDates)}
        onDayPress={(day: any) => { this.onDayPress(day) }}
        firstDay={1}
        theme={getTheme()}
      />
    )
  }
}
